/**
 * Destino depois do login. Quem escaneia o QR sem sessão passa pelo login e volta para a
 * tela de confirmação. O destino só pode ser caminho interno (a regra é a mesma da API).
 */
import { safeReturnPath } from '@es/shared';

/** Endereço do login que, depois de entrar, volta para `caminho`. */
export function loginComRetorno(caminho: string): string {
  const destino = safeReturnPath(caminho);
  return destino ? `/entrar?next=${encodeURIComponent(destino)}` : '/entrar';
}

/** Destino validado vindo de `?next=` (ou do fragmento do login Microsoft). */
export function destinoSeguro(next: string | null | undefined): string {
  return safeReturnPath(next) ?? '/';
}

/** A página do QR que trouxe a pessoa até o login, quando for o caso. */
export function vemDoQr(next: string | null | undefined): boolean {
  return safeReturnPath(next)?.startsWith('/m/') ?? false;
}
